import * as SpeechSDK from 'microsoft-cognitiveservices-speech-sdk';

import { Logger } from '@suntex.core/logging';

import { SpeechToken, getSpeechToken } from './speech-token';

const logger = Logger.for(['synthesizeSpeech']);

export async function synthesizeSpeech(text: string): Promise<void> {
  let speechToken: SpeechToken | null;
  try {
    speechToken = await getSpeechToken();
  } catch (error) {
    logger.warn('Failed to obtain a speech token.', {}, error);
    return;
  }

  if (!speechToken) {
    logger.warn(
      'Speech has not been configured; call configureSpeech() before synthesizing speech.',
    );
    return;
  }

  const speechConfig = SpeechSDK.SpeechConfig.fromAuthorizationToken(
    speechToken.token,
    speechToken.region,
  );

  //specify this voice, to address some weird vowel pronunciations
  //speechConfig.speechSynthesisVoiceName = "en-US-AvaNeural"
  //speechConfig.speechSynthesisVoiceName = "en-US-AvaMultilingualNeural"
  speechConfig.speechSynthesisVoiceName = 'en-US-JennyNeural';

  const synthesizer = new SpeechSDK.SpeechSynthesizer(speechConfig);

  synthesizer.speakTextAsync(
    text,
    () => {
      synthesizer.close();
    },
    (error) => {
      logger.warn('Speech synthesis failed.', {}, error);
      synthesizer.close();
    },
  );
}
